<template>
  <div class="course-table">
    <el-table
      :data="courseSchedule"
      style="width: 100%"
      :cell-style="cellStyle"
    >
      <el-table-column label="课节名称" width="150">
        <template slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-checkbox
              :indeterminate="isIndeterminate(row)"
              v-model="row.notAvailableName"
              @change="handleSelectRow(row)"
              style="margin-right: 5px"
            />
            <el-input v-model="row.courseName" />
          </div>
        </template>
      </el-table-column>

      <!-- 课程时间列 -->
      <el-table-column label="课程时间" width="200">
        <template slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-time-picker
              v-model="row.courseTime"
              is-range
              range-separator="-"
              format="HH:mm"
              value-format="HH:mm"
            ></el-time-picker>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="课节顺序" width="80">
        <template slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-input v-model="row.courseOrder" @blur="checkCourseOrder(row)" />
          </div>
        </template>
      </el-table-column>

      <el-table-column v-for="day in days" :key="day" :label="day">
        <template slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-checkbox
              v-model="row[day].notAvailable"
              style="margin-right: 5px"
              @change="courseSelect(row, day)"
            />
            <el-input
              v-model="row[day].subject"
              :disabled="!row[day].notAvailable"
              :placeholder="row[day].placeholder"
            />
          </div>
        </template>
        <!-- 添加全选功能 -->
        <template slot="header" slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-checkbox
              v-model="selectAll[day].val"
              @change="handleSelectAll(day)"
              style="margin-right: 5px"
              :indeterminate="selectAll[day].isIndeterminateWeek"
            />
            {{ day }}
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              content="勾选即不参与排课"
            >
              <i
                class="el-icon-question"
                slot="reference"
                style="margin-left: 3px; color: #0066cc"
              ></i>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px; text-align: center">
      <el-button @click="addCourse" v-hasPermi="'sc:courseschedule:edit'">添加课节</el-button>
      <el-button @click="deleteCourse" v-hasPermi="'sc:courseschedule:edit'" :disabled="courseSchedule.length === 1"
        >删除课节</el-button
      >
      <el-button @click="saveSchedule" v-hasPermi="'sc:courseschedule:edit'">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gradeId: {
      typeof: [String, Number],
    },
    courseScheduleData: {
      typeof: Array,
    },
  },
  data() {
    return {
      days: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      courseSchedule: [
        // 初始数据
        {
          courseOrder: "",
          courseName: "",
          courseTime: "",
          notAvailableName: false,
          周一: { subject: "", notAvailable: false, placeholder: "" },
          周二: { subject: "", notAvailable: false, placeholder: "" },
          周三: { subject: "", notAvailable: false, placeholder: "" },
          周四: { subject: "", notAvailable: false, placeholder: "" },
          周五: { subject: "", notAvailable: false, placeholder: "" },
          周六: { subject: "", notAvailable: false, placeholder: "" },
          周日: { subject: "", notAvailable: false, placeholder: "" },
        },
      ],
      selectAll: {
        周一: { val: "", isIndeterminateWeek: false },
        周二: { val: "", isIndeterminateWeek: false },
        周三: { val: "", isIndeterminateWeek: false },
        周四: { val: "", isIndeterminateWeek: false },
        周五: { val: "", isIndeterminateWeek: false },
        周六: { val: "", isIndeterminateWeek: false },
        周日: { val: "", isIndeterminateWeek: false },
      }, // 记录每列的全选状态
      firstInput: true, // 标记是否是第一次输入课节顺序
      // isIndeterminateWeek: false,
    };
  },
  watch: {
    courseScheduleData(arr) {
      if (arr) {
        // console.log("arr:", arr);
        this.courseSchedule = arr;
        // 遍历周数
        this.days.forEach((day) => {
          // 在这里执行你的操作，比如调用 courseSelect 方法
          // this.courseSelect(day);
        });
      }
    },
  },
  methods: {
    addCourse() {
      // const lastCourse = this.courseSchedule[this.courseSchedule.length - 1];
      // const newCourseOrder = lastCourse.courseOrder
      //   ? parseInt(lastCourse.courseOrder) + 1
      //   : 1;

      const newCourse = {
        courseOrder: "",
        courseName: "",
        courseTime: "",
        notAvailable: false,
      };

      this.days.forEach((day) => {
        newCourse[day] = { subject: "", notAvailable: false };
      });

      this.courseSchedule.push(newCourse);
    },
    deleteCourse() {
      if (this.courseSchedule.length > 1) {
        this.courseSchedule.pop();
      } else {
        this.$message.warning("至少需要保留一条课程数据");
      }
    },
    saveSchedule() {
      // 新建一个数组，用于存储格式化后的数据
      const formattedData = [];

      // 遍历检测每行数据
      for (let i = 0; i < this.courseSchedule.length; i++) {
        const row = this.courseSchedule[i];

        // 检测 courseName, courseTime 是否为空
        if (!row.courseName || !row.courseTime) {
          this.$message.error(`第${i + 1}行数据不完整，请填写完整的课程信息`);
          return; // 如果有一行数据不完整，直接返回，不再继续检测
        }

        // 遍历所有星期
        for (const day of this.days) {
          // 检查该天的数据是否为空
          // if (
          //   row[day].subject ||
          //   (row[day].notAvailable && !row[day].subject)
          // ) {

          // }
          // 格式化数据并加入新数组
          const formattedRow = {
            gradeId: this.gradeId, // 这里填写具体的 gradeId，如果是动态的，请从数据中获取
            lessonsName: row.courseName,
            lessonsSequence: row.courseOrder,
            lessonContent: row[day].subject || "", // 若 subject 为空，设为空字符串
            week: this.days.indexOf(day) + 1, // 设置星期对应的数值，这里假设周一是1，周二是2，以此类推
            status: row[day].notAvailable ? 0 : 1, // 根据 notAvailable 属性设定 status 值
            startTime: row.courseTime[0], // 你的时间选择器返回的是数组，取第一个元素作为 startTime
            endTime: row.courseTime[1], // 你的时间选择器返回的是数组，取第二个元素作为 endTime
          };

          // 将格式化后的数据加入新数组
          formattedData.push(formattedRow);
        }
      }

      // 如果都通过检测，执行保存逻辑
      // 保存逻辑...
      // console.log("formattedData:", formattedData);
      this.post(this.$url.editBatchCourseConstruction, formattedData).then(
        (res) => {
          // 判断响应状态
          if (res.code !== 200) {
            // 返回错误信息
            return this.$message.error(res.msg);
          }
          this.$message.success("保存成功");
          // 刷新课程计划列表
          this.$emit("lessonPlanRefresh", this.gradeId);
        }
      );
    },
    // 检测课节顺序
    checkCourseOrder(row) {
      const currentOrder = parseInt(row.courseOrder);

      // 第一次输入课节顺序时，必须为1
      // if (this.firstInput && currentOrder !== 1) {
      //   this.$message.error("第一次输入课节顺序时必须为1");
      //   row.courseOrder = ""; // 清空当前行的课节顺序
      // }

      // for (let i = this.courseSchedule.length - 2; i >= 0; i--) {
      //   const prevRow = this.courseSchedule[i];

      //   // 如果前一行有课节顺序，则进行对比
      //   if (prevRow.courseOrder) {
      //     const prevOrder = parseInt(prevRow.courseOrder);
      //     console.log(currentOrder, prevOrder);

      //     // 当前行输入的值必须大于之前行的课节顺序
      //     if (currentOrder <= prevOrder && !this.firstInput) {
      //       this.$message.error("课节顺序必须大于上一次课节顺序");
      //       row.courseOrder = ""; // 清空当前行的课节顺序
      //       return;
      //     } else {
      //       // 如果有课节顺序，停止检测
      //       this.firstInput = false; // 将标记置为false
      //       break;
      //     }
      //   }
      // }
    },
    cellStyle({ rowIndex }) {
      return rowIndex % 2 === 0 ? "background-color: #f2f2f2;" : "";
    },
    isIndeterminate(row) {
      const selectedCount = this.days.reduce((count, day) => {
        if (row[day].notAvailable) {
          return count + 1;
        }
        return count;
      }, 0);

      return selectedCount > 0 && selectedCount < this.days.length;
    },
    // 处理行的全选
    handleSelectRow(row) {
      const isAllSelected = this.days.every((day) => row[day].notAvailable);
      row.notAvailableName = !isAllSelected;
      this.days.forEach((day) => {
        row[day].notAvailable = !isAllSelected;
        row[day].placeholder = row[day].notAvailable ? "填写自定义课程" : "";
        row[day].subject = row[day].notAvailable ? row[day].subject : "";
      });
    },
    // 处理列的全选
    handleSelectAll(day) {
      this.courseSchedule.forEach((row) => {
        row[day].notAvailable = this.selectAll[day].val;
        row[day].placeholder = row[day].notAvailable ? "填写自定义课程" : "";
        row[day].subject = row[day].notAvailable ? row[day].subject : "";
      });
      this.selectAll[day].isIndeterminateWeek = this.selectAll[day].val;
    },
    courseSelect(row, day) {
      // console.log(this.courseSchedule);
      const isAllSelected = this.courseSchedule.every(
        (item) => item[day].notAvailable
      );
      this.selectAll[day].isIndeterminateWeek = isAllSelected;
      this.selectAll[day].val = isAllSelected;

      row[day].placeholder = row[day].notAvailable ? "填写自定义课程" : "";
      row[day].subject = row[day].notAvailable ? row[day].subject : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseScheduleTable.scss";
</style>
